import { cn } from "utils/helpers";
import { useField } from "formik";
import { MultipleCheckbox } from "components/RFQ/MultipleCheckbox";
import { BidderQuestionnaireHeader } from "./BidderQuestionnaireHeader";
import { useOptions } from "../hooks/useOptions";
export const MultipleChoiceQuestionnaire = ({
	className,
	description,
	question,
	required,
	options,
	fieldValue,
	isClientPreview = false,
	previewQuestion = null,
	...props
}) => {
	const [, { error }] = useField(props);

	const checkboxes = useOptions({
		isClientPreview,
		fieldValue,
		previewQuestion,
	});

	return (
		<div
			className={cn(!props?.rfqSubmission && "space-y-2", className)}
			data-testid={`header-${props?.name}`}
		>
			<BidderQuestionnaireHeader
				question={question}
				required={required}
				error={error}
				touchedField={props?.touchedField}
				description={props?.rfqSubmission ? "Select one or more option" : null}
			/>
			<div>
				<MultipleCheckbox
					name={props?.name || "questionnaire"}
					checkboxes={checkboxes}
					className="my-4 w-full"
					noAttribute
					border
					disabled={props?.disabled}
					{...props}
				/>
			</div>
		</div>
	);
};
